import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HsHomepageEventFilter } from '../shared/interfaces/employer-event-filter';
import { ApiHelper } from '../core/services/api-helper';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HsHomepageService extends ApiHelper {
  getEvents(staffId: number, filters: HsHomepageEventFilter, pageNumber: number, pageSize: number): Observable<any> {
    const pagination = {
      skip: pageNumber * pageSize,
      take: pageSize,
    };

    const params = new HttpParams()
      .set('filters', JSON.stringify(filters))
      .set('pagination', JSON.stringify(pagination))
      .set('staffId', staffId.toString());

    const url = `${environment.API_URL}v2/HsHomepage/HealthAndSafetyEvents`;
    return this.getWithAccessToken(url, params);
  }

  getELI(staffId: number, filters: HsHomepageEventFilter, pageNumber: number, pageSize: number): Observable<any> {
    const pagination = {
      skip: pageNumber * pageSize,
      take: pageSize,
    };

    const params = new HttpParams()
      .set('filters', JSON.stringify(filters))
      .set('pagination', JSON.stringify(pagination))
      .set('staffId', staffId.toString());

    const url = `${environment.API_URL}v2/HsHomepage/HealthAndSafetyELI`;
    return this.getWithAccessToken(url, params);
  }

  getMissingAppraisal(
    staffId: number,
    filters: HsHomepageEventFilter,
    pageNumber: number,
    pageSize: number
  ): Observable<any> {
    const pagination = {
      skip: pageNumber * pageSize,
      take: pageSize,
    };

    const params = new HttpParams()
      .set('filters', JSON.stringify(filters))
      .set('pagination', JSON.stringify(pagination))
      .set('staffId', staffId.toString());

    const url = `${environment.API_URL}v2/HsHomepage/HealthAndSafetyMissingAppraisal`;
    return this.getWithAccessToken(url, params);
  }

  getErrors(staffId: number, filters: HsHomepageEventFilter, pageNumber: number, pageSize: number): Observable<any> {
    const pagination = {
      skip: pageNumber * pageSize,
      take: pageSize,
    };

    const params = new HttpParams()
      .set('filters', JSON.stringify(filters))
      .set('pagination', JSON.stringify(pagination))
      .set('staffId', staffId.toString());

    const url = `${environment.API_URL}v2/HsHomepage/EmployerEventsWithFutureTermination`;
    return this.getWithAccessToken(url, params);
  }

  getEventFilterOptions(staffId: number) {
    const params = new HttpParams().set('staffId', staffId.toString());

    return this.getWithAccessToken(`${environment.API_URL}v2/HsHomepage/Events/FilterOptions/` + staffId, params);
  }
}
